// Contact Details filter is stored as { types: [], exclude_without: bool }.
export const isContactDetailsActive = (cd) =>
  !!cd &&
  ((Array.isArray(cd.types) && cd.types.length > 0) || cd.exclude_without === true);

// Drop the object from the request when nothing is selected.
export const contactDetailsPayload = (cd) =>
  isContactDetailsActive(cd)
    ? { types: cd.types || [], exclude_without: cd.exclude_without === true }
    : null;
